import { Col } from 'antd'
import { FC, useEffect, useRef } from 'react'
import PerFlexRow from '../FlexRow'
import { IconIndicator, IconIndicatorBackground } from '../IconIndicator/IconIndicator'
import PerText from '../Text'
import './index.less'

export type StatusMessageVariant = 'error' | 'warning'

export type StatusMessageBoxProps = {
  message: string
  variant: StatusMessageVariant
  withTopMargin?: boolean
}

const STATUS_MESSAGE_ICON_BACKGROUND: Record<StatusMessageVariant, IconIndicatorBackground> = {
  error: 'error',
  warning: 'warning',
}

export const StatusMessageBox: FC<StatusMessageBoxProps> = ({ message, variant, withTopMargin = false }) => {
  const statusBoxRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    statusBoxRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }, [message])

  return (
    <div
      ref={statusBoxRef}
      className={`per-status-message-box per-status-message-box--${variant}${
        withTopMargin ? ' per-status-message-box--with-top-margin' : ''
      }`}
    >
      <PerFlexRow align="middle" direction="row">
        <Col>
          <IconIndicator icon="warning_fill" iconSize={12} background={STATUS_MESSAGE_ICON_BACKGROUND[variant]} size="l" />
        </Col>
        <Col span={20} style={{ padding: 0, marginLeft: '16px' }}>
          <PerText fontSize="s">{message}</PerText>
        </Col>
      </PerFlexRow>
    </div>
  )
}
